import { useQuery, UseQueryResult } from 'react-query';
import { FileRecordNew, PathNode } from '../types/file-record';
import { api } from '../api';
import { GetResponseBody } from '../types/api-response';
import { isMock } from '../utilities/is-mock';
import { AxiosError } from 'axios';

type RecordsResponse = {
    records: FileRecordNew[];
    path: PathNode[];
};

async function getFileRecords(
    page: number,
    limit: number,
    filter?: string,
    sort?: string,
    search?: string,
    childId?: string,
    folderId?: string,
    flatView: boolean = false
): Promise<GetResponseBody<RecordsResponse>> {
    const query = isMock()
        ? `page=${page}&limit=${limit}&${filter}&${sort}&${search}&folderId=${folderId}&childId=${childId}`
        : `page=${page}&limit=${limit}&${filter}&${sort}&search=${search}&folderId=${folderId}&childId=${childId}&flatView=${flatView}`;
    const { data } = await api.get(`/file-records?${query}`);
    return data;
}

export function useFileRecords(
    page: number,
    limit: number,
    childId?: string,
    folderId?: string,
    filter?: string,
    sort?: string,
    search?: string,
    flatView?: boolean
): UseQueryResult<GetResponseBody<RecordsResponse>, AxiosError> {
    return useQuery(
        ['file-records', folderId, childId, page, limit, filter, sort, search, flatView],
        () => getFileRecords(page, limit, filter, sort, search, childId, folderId, flatView),
        {
            keepPreviousData: true,
            enabled: Boolean(folderId) && filter !== undefined && search !== undefined && sort !== undefined,
        }
    );
}
